import React from "react";
import { css } from "react-emotion";
import cx from "classnames";

const inputStyle = css`
  width: 100%;
  border: none;
  border: 1px solid #979797;
  background: none;
  outline: none;
  margin: 0 0 10;
  box-shadow: none;
  /* margin-top: 20px; */
  padding: 6px 10px;
  color: #1f3747;
  font-size: 15px;
  box-sizing: border-box;
  border-radius: 3px;
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;

  &:hover,
  :focus {
    border-color: #aed9da;
    opacity: 1;
    transition: opacity 0.4s;
  }

  &::placeholder {
    color: grey;
    font-size: 1rem;
    opacity: 0.8;
    margin: 5px;
  }
`;

const checkBoxStyle = css`
  padding: 0;
  margin: 4px;
  cursor: pointer;
`;

const completed = css`
  opacity: 1;
`;

const numberNoArrows = css`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
`;

export default class InputComponent extends React.Component {
  state = {
    error: null,
    hadValue: null,
  };

  componentDidMount() {
    if (this.props.defaultValue) {
      this.setState({
        hadValue: true,
      });
    }
  }

  onChange = (e) => {
    this.props.onChange(e.currentTarget.value);
    this.setState({
      hadValue: true,
    });
  };

  onChangeCheckBox = () => {
    this.props.onChange(this.props.defaultValue ? 0 : 1);
    this.setState({
      hadValue: true,
    });
  };

  onChangeNumber = (e) => {
    let value = e.currentTarget.value;
    this.props.onChange(parseInt(value) ? parseInt(value) : 0);
    this.setState({
      hadValue: true,
    });
  };

  render() {
    let renderInput;
    const { validateInput, defaultValue, field, noArrows, name } = this.props;
    const { hadValue } = this.state;
    // console.log(noArrows);
    let error = null;

    if (!defaultValue) {
      error = `${field} cannot be empty`;
    }
    if (name && !defaultValue) {
      error = `${name} cannot be empty`;
    }

    switch (this.props.type) {
      case "checkbox":
        renderInput = (
          <input
            className={checkBoxStyle}
            onChange={this.onChangeCheckBox}
            type="checkbox"
            checked={this.props.defaultValue}
            style={{
              borderColor: this.props.color || "",
              width: this.props.width || "",
              fontSize: this.props.fontSize || "",
              textAlign: this.props.centerText ? "center" : "",
              color: this.props.textColor || "#1F3747",
              margin: this.props.margin || "",
              marginRight: this.props.marginRight || "",
              backgroundColor: this.props.background || "none",
              marginBottom: this.props.marginBottom || "",
            }}
          />
        );
        break;
      case "number":
        renderInput = (
          <input
            ref={(node) => (this.node = node)}
            name={this.props.name}
            type="number"
            min={this.props.min}
            max={this.props.max}
            value={this.props.defaultValue || ""}
            placeholder={this.props.field}
            onChange={this.onChangeNumber}
            className={cx(
              inputStyle,
              this.props.completed && completed,
              this.props.noArrows ? numberNoArrows : ""
            )}
            autoFocus={this.props.autoFocus}
            disabled={this.props.disabled}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            style={{
              borderColor: this.props.color || "",
              width: this.props.width || "",
              fontSize: this.props.fontSize || "",
              textAlign: this.props.centerText ? "center" : "",
              color: this.props.textColor || "#1F3747",
              marginLeft: this.props.marginLeft || "",
              backgroundColor: this.props.background || "none",
              marginBottom: this.props.marginBottom || "10px",
            }}
          />
        );
        break;
      default:
        // fallback to dynamically generate input by type
        renderInput = (
          <input
            ref={(node) => (this.node = node)}
            name={this.props.name}
            type="text"
            maxLength={this.props.maxLength}
            value={this.props.defaultValue || ""}
            placeholder={this.props.field}
            onChange={this.onChange}
            className={cx(inputStyle, this.props.completed && completed)}
            autoFocus={this.props.autoFocus}
            disabled={this.props.disabled}
            onFocus={this.props.onFocus}
            onBlur={this.props.onBlur}
            style={{
              borderColor: this.props.color || "",
              width: this.props.width || "",
              fontSize: this.props.fontSize || "",
              textAlign: this.props.centerText ? "center" : "",
              color: this.props.textColor || "#1F3747",
              height: this.props.height,
              marginLeft: this.props.marginLeft || "",
              marginBottom: this.props.marginBottom || "",
              marginTop: this.props.marginTop || "",
              backgroundColor: this.props.background || "none",
              // margin: this.props.margin || "",
            }}
          />
        );
        break;
    }

    return (
      <React.Fragment>
        {renderInput}
        {error && validateInput && hadValue && (
          <p
            style={{
              color: "red",
            }}
          >
            {error}
          </p>
        )}
      </React.Fragment>
    );
  }
}
